export default function ConnectButton() {
	return <appkit-button size="sm" balance="hide" />;
}
